export default {"src":"/_next/static/media/marker_regular.fe25609b.svg","height":24,"width":24};